import RadioButtonOrCheckbox from '../../Utils/RadioButtonOrCheckbox'
import { $red60 } from '../../../../../styles/colors/primitives'
import Text from '../../../../Text'
import React from 'react'
import styles from './styles.module.css'
import OptimizedImage from '../../../../OptimizedImage'
import { formatPrice } from '../../../../../utils/formats'
import { getShopItemPrice } from '../../../../../utils/shopItemsAndCart'
import { buildCheckoutPageUrlFromProductSetId, isPreOrder } from '../../../../../utils/shopItems'
import { useUrlRegion } from '../../../../../utils/useCurrentRegion'
import LaunchIcon from '../../../../icons/LaunchIcon'
import SmartLink from '../../../../SmartLink'
import CtaV2 from '../../../../CtaV2'
import AddIcon from '../../../../icons/AddIcon'
import { useAddToCart } from '../../../../hooks/useAddToCart'
import CheckmarkIcon from '../../../../icons/CheckmarkIcon'
import { $preOrder } from '../../../../../styles/colors/semantics'
import PreOrderTag from '../../../../ShopItem/PreOrderTag'
import { toSrc } from '../../../../../utils/imageSrc'

const cx = (...c) => c.filter(Boolean).join(' ')

function PairsWellWith({ item, isItemInCart, isMainOfferInCart, isSelected, isAvailable, onCheckboxClick }) {
  const { checkoutPageAddToCart } = useAddToCart()
  const region = useUrlRegion()

  const isPreOrderItem = isPreOrder(item)

  const selected = isSelected || isItemInCart
  const selectedClass = selected
    ? (isPreOrderItem ? styles.offerWrapperSelectedPreOrder : styles.offerWrapperSelected)
    : null

  return (
     <div
       className={cx(styles.offerWrapper, selectedClass, !isAvailable && styles.offerWrapperDisabled)}
       onClick={() => !isMainOfferInCart && onCheckboxClick()} key={item.name}
     >
       {
         !isMainOfferInCart && !isItemInCart && <RadioButtonOrCheckbox
           isSelected={isSelected}
           checkboxStyle={true}
           checkedColor={isPreOrderItem ? $preOrder : $red60}
         />
       }
       <div className={styles.imageWrapper}>
         {/* item.imageUrl is a ResolvedImage descriptor post-#67 normalizeOffers;
             pass it as `image` so <Img> serves the variant ladder + dims. Fall
             back to a bare `src` (via toSrc) for any legacy string value. */}
         <OptimizedImage
           image={item.imageUrl && typeof item.imageUrl === 'object' ? item.imageUrl : undefined}
           src={toSrc(item.imageUrl)}
           alt={item.name}
           sizes="64px"
         />
       </div>
       <div className={styles.offerText}>
         <div className={styles.offerTitleWrapper}>
           <div className={cx(styles.preOrderTagOverride, !isPreOrderItem && styles.preOrderTagOverrideHidden)}>
             <PreOrderTag show={isPreOrderItem}/>
           </div>
           <SmartLink
             href={buildCheckoutPageUrlFromProductSetId(item.productSetId, region)}
             className={styles.offerTitle}
             target="_blank"
             rel="noopener noreferrer"
             onClick={(e) => {e.stopPropagation()}}
           >
             <Text type="tiny">{item.name}</Text>
           </SmartLink>
           { isMainOfferInCart || isItemInCart
             ? (
               <div
                 className={cx(styles.ctaWrapper, isItemInCart && (isPreOrderItem ? styles.ctaWrapperInCartPreOrder : styles.ctaWrapperInCart))}
               >
                 <CtaV2
                   title={isItemInCart ? 'Item added' : `Add for ${formatPrice(getShopItemPrice(item))}`}
                   light={isItemInCart}
                   titleIcon={isItemInCart
                     ? <div className={styles.iconWrapper} style={{ transform: 'scale(0.66)' }}><CheckmarkIcon color="currentColor" /></div>
                     : <div className={styles.iconWrapper} style={{ transform: 'scale(0.85)' }}><AddIcon/></div>
                     }
                   onClick={(e) => {
                     e.stopPropagation()
                     checkoutPageAddToCart([item.id])
                   }}
                   sx={{
                     background: isPreOrderItem ? $preOrder : null,
                     height: '32px',
                     titleTextType: 'tiny',
                     titleToIconGap: '0px'
                   }}
                 />
               </div>
             )
             : <Text type="small">{formatPrice(getShopItemPrice(item))}</Text>
           }
         </div>

       </div>
     </div>
  )
}

export default PairsWellWith
